/*
 * @Author: Dong
 * @Date: 2022-04-06 13:56:03
 * @LastEditors: Dong
 * @LastEditTime: 2022-05-06 17:59:40
 */

import React from 'react';
import { render } from 'react-dom';
import 'sup-ui/dist/sup-ui.less';
import 'sup-rc-table/dist/index.less';
import App from './App';
import './index.less';

render(<App />, document.getElementById('root'));
